import { render, staticRenderFns } from "./ST_120.vue?vue&type=template&id=53d32530&scoped=true&"
import script from "./ST_120.vue?vue&type=script&lang=ts&"
export * from "./ST_120.vue?vue&type=script&lang=ts&"
import style0 from "./ST_120.vue?vue&type=style&index=0&id=53d32530&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53d32530",
  null
  
)

export default component.exports